import { ForwardedRef, forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { RootComponent } from '../../services/root-component';
import { Props } from './types';
import { Mode } from './enums';
import { modePresets } from './model';
import css from './style.module.css';

export const Layout = forwardRef(function Component<T>(
  { Component = 'section', mode = Mode.PLAIN, children, ...props }: Props<T>,
  forwardedRef: ForwardedRef<T>
) {
  return (
    <RootComponent
      {...props}
      Component={Component}
      baseClassName={clsx(css.root, modePresets[mode])}
      ref={forwardedRef}
    >
      <div className={css.body}>{children}</div>
    </RootComponent>
  );
});
